import { useState } from 'react';
import { api } from '../../../lib/api';
import { CreateProductDto, Product } from '../../../types/products';

export function useCreateProduct(onSuccess?: (id: string) => void) {
  const [form, setForm] = useState<CreateProductDto>({ sku: '', name: '', price: 0, imageUrl: '', description: '' });
  const [imageFile, setImageFile] = useState<File | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const setField = <K extends keyof CreateProductDto>(key: K, value: CreateProductDto[K]) => {
    setForm(prev => ({ ...prev, [key]: value }));
  };

  const submit = async () => {
    setLoading(true);
    setError(null);
    try {
      const fd = new FormData();
      if (form.sku && form.sku.trim() !== '') fd.append('sku', form.sku.trim());
      fd.append('name', form.name);
      fd.append('price', String(Number(form.price)));
      if (form.description) fd.append('description', form.description);
      if (imageFile) fd.append('image', imageFile);
      const res = await api.post<{ data: Product }>("/products", fd);
      onSuccess?.(res.data.id);
    } catch (e: any) {
      setError(e.message || 'Failed to create');
    } finally {
      setLoading(false);
    }
  };

  return { form, setField, submit, loading, error, setImageFile };
}
